<div class="employer-selection-modal">
  <h2 mat-dialog-title>{{ 'Reports.Generate540LimitUsage' | translate }}</h2>

  <mat-dialog-content>
    <p>{{ 'Reports.Generate540LimitUsageDescription' | translate }}</p>
    <div class="employers-selection">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'Reports.EmployerUser' | translate }}</mat-label>
        <mat-select
          [formControl]="selectedEmployersControl"
          multiple>
          @for (employer of listOfEmployers$ | async; track employer) {
            <mat-option [value]="employer.Id">
              {{ employer.Name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
      {{ 'Cancel' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="!canGenerate"
      (click)="onGenerate()">
      {{ 'Reports.GenerateReport' | translate }}
    </button>
  </mat-dialog-actions>
</div>
